/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetPromotionSitesResponseType,
  GetReferrerSitesResponseType,
  PostGeoLocationResponseType,
  PostPlatformStatsResponseType,
  PostStatsPayloadType,
  PostStatsResponseType,
} from "~/features/dashboard/types";

const DashboardApi = {
  postStats: (payload: PostStatsPayloadType) => ApiCaller.post<PostStatsResponseType>("/v1/report/totalstats", payload),

  getReferrerSites: () => ApiCaller.get<GetReferrerSitesResponseType>("/v1/reseller/referrer"),

  getPromotionSites: () => ApiCaller.get<GetPromotionSitesResponseType>("/v1/sitepromotion/promotions"),

  postPlatformStats: (payload: PostStatsPayloadType) =>
    ApiCaller.post<PostPlatformStatsResponseType>("/v1/report/platformstats", payload),

  postGeoReport: (payload: PostStatsPayloadType) =>
    ApiCaller.post<PostGeoLocationResponseType>("/v1/report/georeport", payload),
};

export default DashboardApi;
